module.exports = __webpack_public_path__ + "static/media/lockbox.1248d228.jpg";